'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.isNodeEnv = void 0;
function isNodeEnv() {
    // @ts-ignore
    return typeof window === 'undefined' && !!process;
}
exports.isNodeEnv = isNodeEnv;
